import React, { useEffect, useRef } from "react";
import { useCookieConsent } from "../../context/CookieConsentProvider";
import { useLocation } from "react-router-dom";
import { useAccount } from "../../context/AccountProvider";
import { useAnalytics } from "../../context/AnalyticsProvider";

const ScriptLoader = () => {
  const { hasConsent } = useCookieConsent();
  const location = useLocation();
  const { useGetAccount } = useAccount();
  const { account } = useGetAccount();
  const { setTag } = useAnalytics();

  const gaSent = useRef(new Set());
  const piSent = useRef(new Set());

  // Automatic page impression on route change
  useEffect(() => {
    const path = location.pathname;
    if (!piSent.current.has(path)) {
      piSent.current.add(path);
      const pageName = path === "/" ? "home" : path.replaceAll("/", "_").replace(/^_/, "");
      setTag(pageName);
    }
  }, [location.pathname]);

  useEffect(() => {
    const path = location.pathname;

    if (hasConsent && !gaSent.current.has(path)) {
      gaSent.current.add(path);

      if (!window.dataLayer) window.dataLayer = [];
      const gtag = (...args) => window.dataLayer.push(args);

      if (!document.getElementById("gtag-js")) {
        const gaScript = document.createElement("script");
        gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-GC0GN8WQPK";
        gaScript.async = true;
        gaScript.id = "gtag-js";
        document.head.appendChild(gaScript);

        gaScript.onload = () => {
          gtag("js", new Date());
          gtag("consent", "update", { analytics_storage: "granted" });
          gtag("config", "G-GC0GN8WQPK");
          gtag("event", "sfs_debtor_id", { debtorId: account?.debtorId || "unknown" });
          console.log("GA event sent for:", path);
        };
      }

      if (!document.getElementById("gtm-js")) {
        const gtmScript = document.createElement("script");
        gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-MKVPQH6N";
        gtmScript.async = true;
        gtmScript.id = "gtm-js";
        document.head.appendChild(gtmScript);
      }
    }
  }, [location.pathname, hasConsent, account]);

  return null;
};

export default ScriptLoader;
